exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-6b987b80]{margin:0}.card-arkidian[data-v-6b987b80]{border-radius:15px!important;border:0!important;align-items:center;transition:.2s;z-index:0;margin:10px;background-color:#ececec}.card-arkidian[data-v-6b987b80]:hover{box-shadow:-1px 11px 16px 1px rgba(0,0,0,.32);transition:.2s;transform:scaleX(1.05) scaleY(1.05);z-index:1}@media screen and (max-width:600px){.card-arkidian[data-v-6b987b80]{width:250px;margin:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b987b80","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/arkidian/ArkidianComplete.vue
// module id = 589
// module chunks = 0